<template>
  <form v-on:submit="save">
    <div class="card card-info">
      <div class="card-header">
        <div class="card-title">
          <button v-on:click="news()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"  v-if="screen==='default'">Add New + </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row" v-if="screen==='default'">
          <div class="col-md-12 ">
            <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped table-color" width="100%" id="bs4-table">
                <thead class="bg-info">
                  <tr>
                    <th>
                      Sr.No
                    </th>
                    <th>
                      Old EmpCode
                    </th>
                    <th>
                      Old TeacherName
                    </th>
                    <th>
                      New EmpCode
                    </th>
                    <th>
                      New TeacherName
                    </th>
                    <th>
                      Couse Name
                    </th>
                    <th>
                      Couse Code
                    </th>
                    <th>
                      Section
                    </th>

                    <th>
                      Date
                    </th>
                    <th>
                      Remarks
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in data2">
                    <td>{{index+1}}</td>
                    <td>{{item.empcode}}</td>

                    <td>{{item.EmpName}}</td>
                    <td>{{item.newempcode}}</td>
                    <td>{{item.newempname}}</td>
                    <td>{{item.Course}}</td>
                    <td>{{item.code}}</td>
                    <td>{{item.SectionName}}</td>

                    <td>{{item.date}}</td>
                    <td>{{item.Remarks}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
        <div class="row" v-if="screen === 'enabled'">
          <div class="col-md-6">
            Exisiting Teachers
            <select class="form-control" v-model="empID" v-on:change="loadcourses()">
              <option value="0">--Select Employee--</option>
              <option v-for="item in emp" v-bind:value="item.empID" required>{{item.Name}}</option>
            </select>
          </div>

          <div class="col-md-6">
            Course
            <select class="form-control" v-model="courseID">
              <option value="0">--Select Course--</option>
              <option v-for="item in course" v-bind:value="item.courseID">{{item.Name}}</option>
            </select>

          </div>
          <div class="col-md-4">
            Department
            <select class="form-control" v-model="educationID" v-on:change="loademp2(educationID)" v-bind:disabled="officeID>0">
              <option value="0">--Select  Department--</option>
              <option v-for="item in education" v-bind:value="item.ID">{{item.Name}}</option>
            </select>
          </div>
          <!--<%--<div class="col-md-4">
          Office
          <select class="form-control" v-model="officeID" v-on:change="loademp2(officeID)" v-bind:disabled="educationID>0">
            <option value="0">--Select Office--</option>
            <option v-for="item in office" v-bind:value="item.ID">{{item.Name}}</option>
          </select>
        </div>--%>-->
          <div class="col-md-4">
            New Teacher
            <select class="form-control" v-model="newempID">
              <option value="0">--Select Employee--</option>
              <option v-for="item in empnew" v-bind:value="item.empID">{{item.Name}}</option>
            </select>

          </div>
          <div class="col-md-4">
            <label>Date</label>
            <input type="date" class="form-control" v-model="DateTime" />
          </div>
          <div class="col-md-4">
            Remarks<br />
            <input class="form-control" type="text" v-model="Remarks" />
          </div>

        </div>
      </div>
      <div class="card-footer bg-light">
        <div class="form-actions">
          <div class="row">
            <div class="col-md-12">
              <div class="float-right">

                <div class="form-row" v-if="screen==='enabled'">
                  <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12 text-right">
                    <button class="btn btn-success" type="submit" id="showTbale">Save</button>

                    <button class="btn btn-danger " type="button" id="btnCancel" v-on:click="clear()">Clear</button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        screen: 'default',
        empID: 0, newempID: 0,
        courseID: 0,
        DateTime: '', Remarks: '',
        emp: [], course: [], empnew: [],
        data2: [],
        office: [], education: [], officeID: 0, educationID: 0
      }
    },
    created: function () {
      this.getdata();
      this.getemployees();
      this.getdatas();

    },
    updated: function () {
      $('#bs4-table').DataTable();
    },
    methods: {


      save(e) {
        e.preventDefault();
        startReq();
        var vm = this;

        axios.post('/api/DCApi/editTeacherCouseAllotmentID?secID=' + vm.course.find(x => x.courseID == vm.courseID).secID + '&courseID=' + vm.courseID + '&newempID=' + vm.newempID + '&Remarks=' + vm.Remarks + '&date=' + vm.DateTime + '&empID=' + vm.empID)
          .then(function (res) {

            toastr.success("Saved Successfully", "Done!");
            setTimeout(function () { window.location.reload() }, 3000);

          })
          .then(function (error) {
            console.log(error);
          })
      },

      getdata() {
        startReq();
        var vm = this;

        axios.post('/api/DCApi/getdataofteachercouseallotment')
          .then(function (res) {
            vm.data2 = res.data.result;
            vm.DateTime = res.data.date;
            endReq();
            console.log(res);
          })
          .then(function (error) {
            console.log(error);
          })
      },

      getdatas() {
        startReq();
        var vm = this;

        axios.post('/api/DCApi/getdepartmenanddesignation')
          .then(function (res) {
            vm.office = res.data.office;
            vm.education = res.data.education;
            endReq();
            console.log(res);
          })
          .then(function (error) {
            console.log(error);
          })
      },

      news() {
        this.screen = "enabled";
      },

      clear() {
        window.location.reload();
      },

      getemployees() {
        startReq();
        var vm = this;
        vm.evaluationmaster = "";
        axios.post('/api/DCApi/loademployeessss')
          .then(function (res) {
            vm.emp = res.data.result;
            endReq();

          })
          .then(function (error) {
            console.log(error);
          })
      },

      loadcourses() {
        startReq();
        var vm = this;
        axios.post('/api/DCApi/loadcourses3?ID=' + vm.empID)
          .then(function (response) {
            vm.course = response.data.result;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loademp2() {
        startReq();
        var vm = this;
        vm.evaluationmaster = "";
        axios.post('/api/DCApi/loademployees2?officeID=' + vm.officeID + '&educationID=' + vm.educationID)
          .then(function (res) {
            vm.empnew = res.data.result;
            endReq();

          })
          .then(function (error) {
            console.log(error);
          })
      },
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/teacherChangeCourseAllotment.vue